import { handleActions } from 'redux-actions'

import {
  createCompanyRequest,
  createCompanySucceed,
  getCompanyDetailRequest,
  getCompanyDetailSucceed,
  getCompanyListRequest,
  getCompanyListSucceed,
  getCompanyStatusStatisticsRequest,
  getCompanyStatusStatisticsSucceed,
  requestFailure,
  updateCompanyRequest,
  updateCompanyStatusRequest,
  updateCompanyStatusSucceed,
  updateCompanySucceed
} from './actions'

export const INITIAL_STATE = {
  processing: {
    getCompanyStatistics: false,
    getCompanyList: false,
    getCompanyDetail: false,
    createOrUpdatingCompany: false
  },
  companyStatistics: null,
  companyList: null,
  companyDetail: null
}

type State = typeof INITIAL_STATE

export const companyReducer = handleActions<State, any>(
  {
    [getCompanyStatusStatisticsRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getCompanyStatistics: true
      }
    }),
    [getCompanyStatusStatisticsSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getCompanyStatistics: false
      },
      companyStatistics: payload
    }),
    [getCompanyListRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getCompanyList: true
      }
    }),
    [getCompanyListSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getCompanyList: false
      },
      companyList: payload
    }),
    [getCompanyDetailRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getCompanyDetail: true
      }
    }),
    [getCompanyDetailSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getCompanyDetail: false
      },
      companyDetail: payload
    }),
    [createCompanyRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCompany: true
      }
    }),
    [createCompanySucceed.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCompany: false
      }
    }),
    [updateCompanyRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCompany: true
      }
    }),
    [updateCompanySucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCompany: false
      },
      companyDetail: payload
    }),
    [updateCompanyStatusRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCompany: true
      }
    }),
    [updateCompanyStatusSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingCompany: false
      },
      companyDetail: payload
    }),
    [requestFailure.toString()]: (state) => ({
      ...state,
      processing: INITIAL_STATE.processing
    })
  },
  INITIAL_STATE
)
